export const siteSettings = {
  name: "Alpha Markets",
  link: "https://alphamarketspro.org",
  email: "support@alphamarketspro.org",
  appLink: "https://app.alphamarketspro.org",
};
